export interface TutorialStep {
  id: string;
  title: string;
  hint: string;
  rewardExp: number;
  rewardItems?: { itemId: string; quantity: number }[];
}

// 순차 8단계 온보딩 — 이전 단계 완료 시 다음 단계가 자동으로 active된다.
export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: "first_day",
    title: "첫 출근",
    hint: "깃 마스터에게 다가가 말을 걸어보자.",
    rewardExp: 10,
  },
  {
    id: "first_bug",
    title: "첫 번째 버그",
    hint: "저기 초록색 놈 보이지? 가까이 가서 [E]를 눌러. 몸으로 때우는 게 아니라 머리로 잡는 거야.",
    rewardExp: 20,
  },
  {
    id: "gear_check",
    title: "장비 점검",
    hint: "사냥했더니 집중력이 좀 빠졌지? [I] 눌러서 커피 마셔. 개발자의 연료지.",
    rewardExp: 10,
  },
  {
    id: "growing_dev",
    title: "성장하는 개발자",
    hint: "스킬(📚)에서 HTML 기초를 배워봐. 30분 걸리는데, 접속 안 해도 알아서 진행돼. 시작만 해두고 네 할 일 하면 돼.",
    rewardExp: 10,
  },
  {
    id: "first_gig",
    title: "첫 의뢰",
    hint: "이제 돈 벌 시간이야. 프로젝트(📋)에서 제일 만만한 걸 골라봐. \"복붙만 하면 된다\"는 말은 믿지 말고.",
    rewardExp: 10,
  },
  {
    id: "first_work",
    title: "첫 작업",
    hint: "작업하다 보면 별의별 일이 다 생겨. 잘 골라. 정답은 없지만 오답은 있어.",
    rewardExp: 10,
  },
  {
    id: "delivery",
    title: "납품",
    hint: "첫 보수 축하해. 3.3% 떼인 거 보이지? 그게 프리랜서의 삶이야. 5월에 돌려받... 을 수도 있어.",
    rewardExp: 20,
  },
  {
    id: "clock_out",
    title: "퇴근",
    hint: "마지막이야. [Tab] 눌러봐. 여기가 네 상황판이야. 아까 시작한 HTML 학습, 30분 뒤에 끝나. 내일 출근하면 완료돼 있을 거야. 그럼 퇴근해. 여긴 야근 강요 안 하니까.",
    rewardExp: 30,
    rewardItems: [{ itemId: "coffee", quantity: 3 }],
  },
];

export const FIRST_TUTORIAL_STEP_ID = TUTORIAL_STEPS[0].id;

// 튜토리얼 전용 강제 이벤트("첫 작업" 단계에서 100% 발생) 대상 이벤트 id.
export const TUTORIAL_FORCED_EVENT_ID = "meeting_summons";

export function nextTutorialStepId(stepId: string): string | null {
  const idx = TUTORIAL_STEPS.findIndex((s) => s.id === stepId);
  if (idx === -1 || idx === TUTORIAL_STEPS.length - 1) return null;
  return TUTORIAL_STEPS[idx + 1].id;
}
